import React from 'react';
import { Spinner } from '../Spinner';
import { Box } from '../Box';
export var TableSpinner = function () {
    return (React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "center", my: "xs", backgroundColor: "white" },
        React.createElement(Spinner, { size: "small", altText: "table content is loading" })));
};
//# sourceMappingURL=TableSpinner.js.map